import React, { type FC, useCallback, useMemo, useRef } from 'react';
import { AssistantChatInput } from './uiManager/assistant-chat-input/AssistantChatInput';
import { Suggestions } from './Suggestions';
import { useAssistant } from './hooks/useAssistant';
import { PiTitle } from 'features/pi/view/uiManager/titles/pi-title';
import styles from './new-conversation-panel.module.scss';
import { SuggestionChips } from './uiManager/suggestion-chips/suggestion-chips';
import { IRichTextEditor } from './uiManager/assistant-chat-input/RichTextEditor';

export const NewConversationPanel: FC = () => {
    const { suggestions, getSuggestions, createConversation } = useAssistant();
    const editorRef = useRef<IRichTextEditor | null>(null);

    const hasSuggestions: boolean = useMemo(() => {
        const suggestionItems = suggestions?.items.getOrderedItems() || [];
        return suggestionItems.length > 0;
    }, [suggestions?.items]);

    const handleTextChanged = useCallback(
        (content: string) => {
            getSuggestions(content);
        },
        [getSuggestions],
    );

    const handleChipClick = useCallback(
        (text: string) => {
            if (editorRef.current) {
                editorRef.current.setContent(text);
                handleTextChanged(text);
            }
        },
        [handleTextChanged],
    );

    return (
        <div className={styles.conversationContainer}>
            <PiTitle text={'What can I help with?'} additionalClassName={styles.piTitle} />
            <AssistantChatInput
                onEditorReady={(editor) => {
                    editorRef.current = editor;
                }}
                onSubmit={createConversation}
                onTextChanged={handleTextChanged}
            />
            {hasSuggestions && (
                <Suggestions
                    suggestions={suggestions}
                    onSelect={(suggestion) => createConversation(suggestion.query.get(), undefined)}
                />
            )}
            {!hasSuggestions && <SuggestionChips onClick={handleChipClick} />}
        </div>
    );
};
